import { render, staticRenderFns } from "./FormItemSkuList.vue?vue&type=template&id=0f53233e&scoped=true"
import script from "./FormItemSkuList.vue?vue&type=script&lang=js"
export * from "./FormItemSkuList.vue?vue&type=script&lang=js"
import style0 from "./FormItemSkuList.vue?vue&type=style&index=0&id=0f53233e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f53233e",
  null
  
)

export default component.exports